import { useEffect } from "react";
import { useDispatch } from "react-redux"
import {setSelectedMenu, setOpenKeys} from '../redux'

export const useNavs=(keys, activeMenu)=>{
    const dispatch=useDispatch();
    useEffect(()=>{
        const selMenu=[];
        const openKeys=[];
        const active = `${activeMenu}`.toLowerCase();
        for (let iii = 0; iii < keys.length; iii++) {
            const {key, withChildren} = keys[iii];
            const k = `${key}`.toLowerCase();
            if (active === k || active.startsWith(k + '/')) {
                selMenu.push(key);
                if(withChildren){
                    openKeys.push(key);
                }
            }
        }
        dispatch(setSelectedMenu(selMenu.pop()));
        dispatch(setOpenKeys(openKeys));
    }, [keys, activeMenu, dispatch]);
}